<script setup>
import { RouterLink, RouterView } from 'vue-router'
</script>
<script>
//import '@/assets/js/lib/jquery-3.5.1.min.js';
import '@/assets/js/lib/bootstrap.bundle.min.js';
import '@/assets/js/lib/jquery.nice-select.min.js';
//import '@/assets/js/lib/circle-progress.min.js';
import '@/assets/js/lib/slick.min.js';

export default {
  name: 'App'
}
</script>
<template>
  <RouterView />
</template>

<style>
@import "./assets/css/bootstrap.min.css";
@import "./assets/css/nice-select.css";
@import "./assets/css/slick.css";
@import "./assets/css/style.css";
@import "./assets/css/responsive.css";
</style>


// WEBPACK FOOTER //
// src/App.vue